export const CURRENT_TOKEN_KEY = '__firebaseCurrentToken__';

export const getFirebaseToken = (tokenKey: string) => {
  const parsedFirebaseToken = parseFirebaseToken(tokenKey);
  return parsedFirebaseToken;
};

export function saveCurrentFirebaseToken(currentToken: string) {
  const firebaseTokenCurrent = currentToken;
  localStorage.setItem(CURRENT_TOKEN_KEY, JSON.stringify(firebaseTokenCurrent));
}
export const removeFirebaseToken = () => {
  localStorage.removeItem(CURRENT_TOKEN_KEY);
};
export const parseFirebaseToken = (tokenKey: string) => {
  try {
    return localStorage?.getItem(tokenKey)
      ? JSON.parse(localStorage?.getItem(tokenKey) ?? '')
      : '';
  } catch (error) {
    removeFirebaseToken();
  }
  return JSON.parse(localStorage?.getItem(tokenKey) ?? '');
};
